export enum EProductionOrdersTab {
	FUTURE = 'future',
	HISTORY = 'history',
}

export const productionOrderTypeMap: Record<string, string> = {
	ClientDietDay: 'Zamówienie klienta',
	InternalOrder: 'Zlecenie wewnętrzne',
}

export const PRODUCTION_ORDER_SORT_FIELD_BY_COLUMN: Record<string, string> = {
	deliveryDate: 'delivery_date',
	totalMeals: 'total_meals',
	totalOrders: 'total_orders',
	uniqueMeals: 'unique_meals',
}

export const DEFAULT_PRODUCTION_ORDER_SORT: Record<string, EApiSortType> = {
	delivery_date: EApiSortType.ASC,
}

export const isProductionOrderSortableColumn = (columnField: string) =>
	columnField in PRODUCTION_ORDER_SORT_FIELD_BY_COLUMN
